module.exports = __webpack_public_path__ + "static/media/compress-alt.c00db9d4.svg";